import { render } from "./CompanyIntroduction_2.vue?vue&type=template&id=1a3edbae"
import script from "./CompanyIntroduction_2.vue?vue&type=script&lang=js"
export * from "./CompanyIntroduction_2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__